import { useMutation } from "react-query";
import { AreaComumBloqueioDataItem } from "../typings";
import http from "infra/http";

function useSaveBloqueioDataAreaComum(tenantId: string, areaComumId: string) {
  return useMutation(
    (data: AreaComumBloqueioDataItem[]) => {
      const newData: AreaComumBloqueioDataItem[] = data.map((item) => ({
        id: Number.isInteger(item.id) ? undefined : item.id,
        dataInicio: item.dataInicio,
        items: item.items,
        dataFim: item.dataFim,
        motivo: item.motivo,
      }));

      return http.post(
        `/v1/tenants/${tenantId}/area-comum/${areaComumId}/bloqueio-data`,
        { bloqueioDatas: newData }
      );
    },
    { retry: false }
  );
}

export default useSaveBloqueioDataAreaComum;
